import { MergeReplenishmentSettingsMutation } from "~/gql/mutations/restock/replenishmentSettings.generated";
import { GetReplenishmentSettingsQuery } from "~/gql/queries/restock/replenishmentSettings.generated";

export const replenishmentSettingEndpoints = {
	GetReplenishmentSettings: {
		providesTags: ["ReplenishmentSettings"] as AddTagTypes,
		transformResponse: (res: GetReplenishmentSettingsQuery) => res
	},
	MergeReplenishmentSettings: {
		invalidatesTags: ["ReplenishmentSettings"] as AddTagTypes,
		transformResponse: (res: MergeReplenishmentSettingsMutation) => res
	}
};
